import AccessibilityForm from './AccessibilityForm';

export default AccessibilityForm;
